import React from 'react';
import styles from './BreakdownsContainer.module.scss';

interface Tab {
  name: string;
  value: string;
}

interface BreakdownsContainerTabsProps {
  tabsList: Tab[];
  onChange: (value: string) => void;
  activeTab?: string | null;
}

const BreakdownsContainerTabs: React.FC<BreakdownsContainerTabsProps> = ({
  tabsList,
  onChange,
  activeTab,
}) => {
  return (
    <div className={styles.tabsContainer}>
      {tabsList?.map((tab) => (
        <button
          key={tab.value}
          className={`${styles.tab} ${activeTab === tab.value ? styles.activeTab : styles.inactiveTab}`}
          onClick={() => onChange(tab.value)}
        >
          {tab.name}
        </button>
      ))}
    </div>
  );
};

export default BreakdownsContainerTabs;
